export function calculateFieldValueSum(extras) {
   try {
      // Check if the input is a valid array
      if (!Array.isArray(extras)) {
         throw new Error("Invalid input: extras should be an array.");
      }

      // Use reduce to calculate the sum of field_value
      const sum = extras.reduce((accumulator, item) => {
         // Check if field_value exists and is a valid number
         const value = parseFloat(item.field_value);
         if (isNaN(value)) {
            throw new Error(`Invalid field_value: ${item.field_value} is not a number.`);
         }

         // Add the valid field_value to the accumulator
         return accumulator + value;
      }, 0); // Initial accumulator value is 0

      return sum;
   } catch (error) {
      console.error(error.message);
      return undefined; // Return undefined in case of any errors
   }
}
